import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ErcService } from 'ng2-app/services/erc/erc.service';
import { Injectable } from '@angular/core';
import { GetErcChecklist, PostErcChecklist, PutErcChecklist } from 'ng2-app/store/erc/erc.actions';
import { ErcChecklistModel } from 'ng2-app/models/dto/erc/erc-checklist';

export class ErcChecklist {
  ercChecklistData: ErcChecklistModel;
}

@State<ErcChecklist>({
  name: 'ercChecklistData',
})

@Injectable()

export class ErcState {
  @Selector()
  static ercChecklist(state: ErcChecklist) {
    return state.ercChecklistData;
  }

  constructor(private ercService: ErcService) {
  }

  @Action(GetErcChecklist)
  getErcChecklist({patchState}: StateContext<ErcChecklist>, {borrowerId}: GetErcChecklist) {
    return this.ercService.getErcChecklist(borrowerId).pipe(catchError(err => throwError(() => err)),
      map(ercChecklistData => {
        patchState({ercChecklistData});
      }));
  }

  @Action(PostErcChecklist)
  postErcChecklist({patchState}: StateContext<ErcChecklist>, {borrowerId, page}: PostErcChecklist) {
    return this.ercService.postErcChecklist(borrowerId, page).pipe(catchError(err => throwError(() => err)),
      map(ercChecklistData => {
        patchState({ercChecklistData});
      }));
  }

  @Action(PutErcChecklist)
  putErcChecklist({patchState}: StateContext<ErcChecklist>, {checklistId, borrowerId, page}: PutErcChecklist) {
    return this.ercService.putErcChecklist(checklistId, borrowerId, page).pipe(catchError(err => throwError(() => err)),
      map(ercChecklistData => {
        patchState({ercChecklistData});
      }));
  }
}
